// extracted by mini-css-extract-plugin
module.exports = {"container":"G8COmibBMX3NIKt69nH3H"};